var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"res-topology-wrapper",style:(`height:${_vm.height}px`),attrs:{"id":"res-topology-wrapper"}},[(_vm.loading)?_c('loading-block'):_c('div',{staticClass:"topology",style:(_vm.topologyStyle),attrs:{"id":"topology"}},[_c('account-topology',{attrs:{"dataSource":_vm.data}})],1),_c('toolbar',{on:{"click":_vm.menuClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }